import React, { useState } from 'react';
import { flowRight as compose } from 'lodash';
import { inject, observer } from 'mobx-react';
import { Link } from 'react-router-dom';
import { AppBar, Toolbar, IconButton, Typography, Box, Button, Menu, MenuItem } from '@mui/material';
import { styled } from '@mui/material/styles';

import { Menu as MenuIcon, AccountCircle } from '@mui/icons-material';

import logo from '../../logo.svg';

const styles = {
  root: {
    width: '100%',
    paddingTop: 0,
    backgroundColor: '#f0f0f0',
  },
  topAppBar: {
    paddingBottom: 0,
    minHeight: '52px',
  },
  title: (theme) => ({
    display: 'none',
    [theme.breakpoints.up('sm')]: {
      display: 'block',
      paddingLeft: '10px',
    },
    fontSize: '20px',
    fontFamily: 'AvenirNext-Medium',
  }),
  grow: {
    flexGrow: 1,
  },
  sectionDesktop: (theme) => ({
    display: 'none',
    [theme.breakpoints.up('md')]: {
      display: 'flex',
    },
  }),
  label: {
    fontFamily: 'AvenirNext',
    fontWeight: 400,
  },
  sectionMobile: (theme) => ({
    display: 'flex',
    [theme.breakpoints.up('md')]: {
      display: 'none',
    },
  }),
  menuItem: {
    textDecoration: 'none',
    color: 'inherit',
    minWidth: 150,
  },
};

const StyledButton = styled(Button)({
  '&.MuiButton-colorSecondary': {
    fontFamily: 'AvenirNext',
    fontWeight: 400,
  },
});

function Header(props) {
  const { store } = props;
  const { userStore } = store;

  const { user, account } = userStore;

  const [anchorEl, setAnchorEl] = useState(null);
  const isMenuOpen = Boolean(anchorEl);

  const handleMenuOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const signOut = () => {
    window.location.href = `${import.meta.env.REACT_APP_OAUTH_LOGIN_URL}?logout=true&next=${encodeURI(window.location.href)}`;
  };

  return (
    <Box sx={styles.root}>
      <AppBar color="transparent" position="static">
        <Toolbar sx={styles.topAppBar}>
          <IconButton color="inherit" aria-label="Open drawer">
            <MenuIcon />
          </IconButton>
          <Box>
            <Link to={'/'}>
              <img alt="Jitsu logo" height="40px" src={logo} />
            </Link>
          </Box>

          <Typography sx={styles.title} variant="h6" color="inherit" noWrap>
            DSP Portal
          </Typography>
          <Box sx={styles.grow} />
          <Box sx={styles.sectionDesktop}>
            <StyledButton
              aria-owns={isMenuOpen ? 'material-app-bar' : undefined}
              aria-haspopup="true"
              onClick={handleMenuOpen}
              color="secondary"
              endIcon={<AccountCircle />}
              sx={{ textTransform: 'none' }}
            >
              <span style={{ marginRight: 5, fontSize: 16 }}>{user ? user.name : 'Anonymous'}</span>
              {account && <span style={{ marginRight: 5, fontSize: 12 }}>(@ {account.company})</span>}
            </StyledButton>
          </Box>
        </Toolbar>
      </AppBar>
      <Menu
        anchorEl={anchorEl}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        transformOrigin={{ vertical: 'top', horizontal: 'center' }}
        open={isMenuOpen}
        onClose={handleMenuClose}
      >
        <MenuItem sx={styles.menuItem} component={Link} to="/profile" onClick={handleMenuClose}>
          Profile
        </MenuItem>
        <MenuItem sx={styles.menuItem} onClick={signOut}>
          Sign Out
        </MenuItem>
      </Menu>
    </Box>
  );
}

export default compose(inject('store'), observer)(Header);
